module.exports = __webpack_public_path__ + "static/media/todo.f27b9cf7.png";